module.exports = __webpack_public_path__ + "images/noevox.79bdc5af05cfcdbc6dec1a403e2b3844.png";